export default {"src":"/_next/static/media/wave-promo-general.d587052d.svg","height":1114,"width":4301,"blurWidth":0,"blurHeight":0};